<template>
  <el-dialog title="新增发票类目" :visible.sync="visible">
    <el-form ref="form" size="small" :model="form">
      <el-form-item label="发票类目" prop="invoiceType">
        <el-input placeholder="请选择发票类目，例如，研发和技术服务" v-model="form.invoiceType"></el-input>
      </el-form-item>
      <el-form-item label="服务事项" prop="serviceType">
        <el-select placeholder="请选择服务事项，例如技术服务" v-model="form.serviceType">
          <el-option v-for="(item, index) in serviceTypes" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div>
      温馨提示：
      <span>1、若发票类目不存在，请先联系运营人员添加后再新增</span>
      <span>2、一个发票类目可能对应多个服务事项，请先核对贵司可受理的服务事项</span>
    </div>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'setAmount',
  data() {
    return {
      visible: false,
      serviceTypes: '',
      form: {
        invoiceType: '',
        serviceType: '',
      },
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleClose() {},
    handleConfirm() {},
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/dutyPaid/components/addTracking.vue